// src/hooks/web/useCart.js
import { useState, useCallback } from "react";
import { useCartContext } from "@/contexts/CartContext";

export function useCart() {
    const {
        cartItems,
        addToCart,
        updateQuantity,
        removeFromCart,
        clearCart,
        getTotalItems,
        getTotalPrice,
    } = useCartContext();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Thêm sản phẩm vào giỏ hàng với xử lý loading và error
    const handleAddToCart = useCallback(
        async (product, variant, quantity = 1) => {
            try {
                setLoading(true);
                setError(null);

                // Kiểm tra xem sản phẩm có sẵn để thêm vào giỏ hàng không
                if (!product || !variant) {
                    throw new Error("Sản phẩm không hợp lệ");
                }

                // Thêm vào giỏ hàng thông qua context
                addToCart(product, variant, quantity);

                return true;
            } catch (err) {
                setError(err.message || "Không thể thêm sản phẩm vào giỏ hàng");
                return false;
            } finally {
                setLoading(false);
            }
        },
        [addToCart]
    );

    // Cập nhật số lượng sản phẩm với xử lý loading và error
    const handleUpdateQuantity = useCallback(
        (variantId, quantity) => {
            try {
                setLoading(true);
                setError(null);

                updateQuantity(variantId, quantity);

                return true;
            } catch (err) {
                setError(err.message || "Không thể cập nhật số lượng sản phẩm");
                return false;
            } finally {
                setLoading(false);
            }
        },
        [updateQuantity]
    );

    // Xóa sản phẩm với xử lý loading và error
    const handleRemoveFromCart = useCallback(
        (variantId) => {
            try {
                setLoading(true);
                setError(null);

                removeFromCart(variantId);

                return true;
            } catch (err) {
                setError(err.message || "Không thể xóa sản phẩm khỏi giỏ hàng");
                return false;
            } finally {
                setLoading(false);
            }
        },
        [removeFromCart]
    );

    return {
        cartItems,
        loading,
        error,
        addToCart: handleAddToCart,
        updateQuantity: handleUpdateQuantity,
        removeFromCart: handleRemoveFromCart,
        clearCart,
        getTotalItems,
        getTotalPrice,
    };
}
